import { Auth0AuthProvider } from '@pn/services/authentication/auth0/Auth0AuthenticationProvider';
import { useAuth0AuthenticationService } from '@pn/services/authentication/auth0/auth0AuthenticationService';

/**
 * Default authentication provider and service.
 */
export const AuthProvider = Auth0AuthProvider;
export const useAuthenticationService = useAuth0AuthenticationService;
